import type { Achievement } from "../achievement.types";

export const withinSightAchievement: Achievement = {
  id: "withinSight",
  name: "Within Sight",
  icon: "binoculars",
  description: "Gave up one or two moves from the target.",
  isProgressive: true,
  // Rule unchanged from v1's Six Feet From the Edge (spec 2026-10-20 §3.2).
  check: (gameReport, gameStatus) => {
    if (
      gameStatus !== "given_up" ||
      !gameReport ||
      !gameReport.suggestedPath ||
      gameReport.suggestedPath.length <= 1
    ) {
      // Path must exist and be longer than just the current word
      return false;
    }

    const movesRemaining = gameReport.suggestedPath.length - 1;

    // Award if 1 or 2 moves were remaining
    return movesRemaining === 1 || movesRemaining === 2;
  },
};
